import React, { useState, useEffect, useRef } from 'react'
import store from "@/redux/store";
import { v4 as uuid } from "uuid";
import moment from 'moment';

import {CalenderEvent} from '@/views/ActionHeader/CalenderEvent';
import {SearchBar} from '@/views/ActionHeader/SearchBar';
import {CommunicationCycleHeader} from '@/views/ActionHeader/CommunicationCycleHeader';
import {TimerPanel} from '@/views/TimeRegistration/TimerPanel'
import { Scenario4 , Testerr} from "@/controllers/Window/Search/WindowSearchDossierController";
import {CalenderPanel} from "./CalenderPanel";

    const initial_state = 1;

export function ActionHeaderView({...props}) {
    const [localState, setLocalState] = useState(1);
    const [currentEvent, setCurrentEvent] = useState(null);
    const currentEventRef = useRef(null);
    
    let id = uuid().slice(0, 8);



    
    return (
        <>
        <div className="w-full h-20 border-b mb-4 mt-2 flex flex-row gap-2 pb-2">
            <CommunicationCycleHeader />
            <CalenderPanel />
        </div>
        </>        
    )
}